export default __webpack_public_path__ + "static/media/413.5ca3fa92.jpg";